<div class="grid-container margin-top" >
    <ag-grid-angular class="data-grid  margin-top full-page" [rowData]="data" [gridOptions]="gridOptions" [statusBar]="statusBar" aria-label="Organization List">
    </ag-grid-angular>
</div>